"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _useReloadKey3 = require("web/shared/relay/useReloadKey");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _InternalPageHeader = _interopRequireDefault(require("web/shared/components/InternalPageHeader"));
var _AppAssetList = _interopRequireDefault(require("web/shared/assets/AppAssetList"));
var _readFailureRenderer = require("web/shared/relay/readFailureRenderer");
var _QueryBoundary = _interopRequireDefault(require("web/shared/relay/QueryBoundary"));
var _styles = require("web/shared/assets/styles");
var _consolePage = require("web/shared/console/consolePage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The /internal/assets page: this product's declared app assets with their
* candidates, and under them the keys no screen declares any more.
*
* The page is the chrome and the wording. The reading is one level down, in
* `AppAssetList`, which suspends — so the loading line and the failure line
* are this page's words handed to the boundary rather than state it keeps.
* The boundary sits below the header, so a slow or failed read never takes
* the page's title with it.
*
* Every action reloads the whole listing, which the server reconciles with
* the bucket on each read. The re-read after an action runs as a transition,
* so the listing on screen stays, at its scroll, until the new one replaces
* it; only the first read shows the loading line.
*/
function AppAssetsView() {
  const _useReloadKey = (0, _useReloadKey3.useReloadKey)(),
    _useReloadKey2 = (0, _slicedToArray2.default)(_useReloadKey, 2),
    reloads = _useReloadKey2[0],
    refresh = _useReloadKey2[1];
  const _useTransition = (0, _react.useTransition)(),
    _useTransition2 = (0, _slicedToArray2.default)(_useTransition, 2),
    startRereading = _useTransition2[1];
  const rereadAfterChange = (0, _react.useCallback)(() => {
    startRereading(refresh);
  }, [refresh]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_consolePage.consolePage.inset, _consolePage.consolePage.roomBelow)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InternalPageHeader.default, {
      title: "App assets",
      context: null,
      backTo: null,
      backLabel: null
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_QueryBoundary.default, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.status)), {}, {
        children: "Loading app assets\u2026"
      })),
      renderError: (0, _readFailureRenderer.readFailureRenderer)(_styles.styles.error, refresh),
      resetKey: reloads,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppAssetList.default, {
        reloadKey: reloads,
        onChanged: rereadAfterChange
      })
    })]
  }));
}
var _default = exports.default = AppAssetsView;